import { render, staticRenderFns } from "./transaction-journal.vue?vue&type=template&id=40e151ea&scoped=true"
import script from "./transaction-journal.vue?vue&type=script&lang=js"
export * from "./transaction-journal.vue?vue&type=script&lang=js"
import style0 from "./transaction-journal.vue?vue&type=style&index=0&id=40e151ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e151ea",
  null
  
)

export default component.exports